module.exports = __webpack_public_path__ + "img/adobe-commerce-vs-magento.b64dccb5.webp";